module.exports = __webpack_public_path__ + "static/media/2.7c064f95.svg";